// Topbar - minimal progress bar for LiveView navigation
var topbar = (function() {
  var el, i = 0, t = 0
  function show(delay) {
    clearTimeout(t)
    clearInterval(i)
    delay = delay || 0
    t = setTimeout(function() {
      if (!el) {
        el = document.createElement("div")
        el.style.cssText = "position:fixed;top:0;left:0;right:0;height:3px;background:var(--accent-secondary,#98E012);z-index:9999;transition:width 0.2s,opacity 0.3s;"
        el.style.width = "0%"
        if (document.body) document.body.appendChild(el)
      }
      if (el) {
        el.style.opacity = "1"
        el.style.width = "50%"
      }
    }, delay)
    i = setInterval(function() {
      if (!el) return
      var w = parseFloat(el.style.width) || 0
      if (w < 90) { el.style.width = (w + (90 - w) * 0.1) + "%" }
    }, 200)
  }
  function hide() {
    clearTimeout(t)
    clearInterval(i)
    if (el) {
      el.style.width = "100%"
      setTimeout(function() { if (el) el.style.opacity = "0" }, 50)
      setTimeout(function() { if (el) { el.remove(); el = null } }, 400)
    }
  }
  function config(opts) { return topbar }
  return { show: show, hide: hide, config: config }
})()
export default topbar
